import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'gold' | 'outline' | 'ghost';
type Size = 'sm' | 'md' | 'lg';
const base = 'inline-flex items-center justify-center gap-2 font-medium tracking-wide transition-all duration-300 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ivory disabled:opacity-50 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-ink text-ivory-100 hover:bg-ink-700 shadow-soft hover:shadow-lift',
  gold: 'bg-gold text-ink hover:bg-gold-dark hover:text-ivory-50 shadow-soft hover:shadow-lift',
  outline: 'border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-ivory-100',
  ghost: 'text-ink hover:bg-ink/5'
};
const sizes: Record<Size, string> = {
  sm: 'text-xs px-4 py-2',
  md: 'text-sm px-6 py-3',
  lg: 'text-sm px-8 py-4'
};
interface CommonProps {
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
}
type ButtonAsButton = CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement> & {
  to?: undefined;
  href?: undefined;
};
type ButtonAsLink = CommonProps & {
  to: string;
};
type ButtonAsAnchor = CommonProps & {
  href: string;
};
type ButtonProps = ButtonAsButton | ButtonAsLink | ButtonAsAnchor;
export function Button(props: ButtonProps) {
  const {
    variant = 'primary',
    size = 'md',
    className,
    children
  } = props;
  const classes = twMerge(base, variants[variant], sizes[size], className);
  if ('to' in props && props.to) {
    return <Link to={props.to} className={classes} data-id="element-282" data-mp="1ccd6el9hmq12">
        {children}
      </Link>;
  }
  if ('href' in props && props.href) {
    return <a href={props.href} className={classes} data-id="element-283" data-mp="17geo9fer6493">
        {children}
      </a>;
  }
  const {
    variant: _v,
    size: _s,
    className: _c,
    children: _ch,
    ...rest
  } = props as ButtonAsButton;
  return <button className={classes} {...rest} data-id="element-284" data-mp="1haeq98eqmtdl">
      {children}
    </button>;
}